import { ReactNode, createContext, useContext } from 'react';
import usePostPartnerAccountMatrix from '../hooks/useApi/usePostPartnerAccountMatrix';

import type {
  PartnerAccountMatrixRequest,
  PartnerAccountMatrixResponse,
} from '../hooks/useApi/usePostPartnerAccountMatrix';

type PartnerAccountsMatrixCtx = {
  response: PartnerAccountMatrixResponse | undefined;
  postMatrix: (requestParams: PartnerAccountMatrixRequest) => void;
  reset: () => void;
};

const defaultData = { success: false, errorMessage: '', accountDetails: {}, balances: [], permissions: {} };

export const PartnerAccountMatrixContext = createContext<PartnerAccountsMatrixCtx>({
  response: defaultData,
  postMatrix: () => {},
  reset: () => {},
});

export const PartnerAccountMatrixProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [response, postMatrix, reset] = usePostPartnerAccountMatrix({});

  return (
    <PartnerAccountMatrixContext.Provider
      value={{
        response,
        postMatrix,
        reset,
      }}
    >
      {children}
    </PartnerAccountMatrixContext.Provider>
  );
};

export const usePartnerAccountMatrix = (): PartnerAccountsMatrixCtx => useContext(PartnerAccountMatrixContext);
